export default {
    change_password_title: "Change Password",
    change_password_username: 'Username',
    change_password_new_password: 'New Password',
    change_password_repeat_new_password: 'Repeat New Password',
    change_password_passwords_must_match: 'Passwords must match',
    change_password_it_is_necessary_to_change: 'It is necessary to change the password',
    change_password_the_data_are_not_valid: 'The data are not valid',
    change_password_password_is_changed: 'Password is changed, you can now log in normally',
    change_password_it_is_not_posible_change_password: 'It is not possible to change the password',
};









